import { ROLE_LABEL } from "@bookdental/schemas";
import type { DashboardMode } from "@/lib/dashboard-mode";

export { ROLE_LABEL };

export const INVITE_ROLES = ["PARTNER", "ADMIN", "DENTIST", "ASSISTANT", "RECEPTIONIST", "VIEWER"] as const;
export type InviteRole = (typeof INVITE_ROLES)[number];

/** Beta: na clínica só se atribui Administrador e Dentista. Recepção, Assistente e Visualizador
 *  continuam existindo no enum e no banco — quem já tem segue funcionando igual —, só saíram das
 *  telas enquanto o desenho de permissões amadurece. Laboratório (e organização híbrida, que tem
 *  o lado laboratório) mantém os cinco. */
const PAPEIS_DO_BETA_CLINICA: InviteRole[] = ["ADMIN", "DENTIST"];

/**
 * Papéis que aparecem pra escolher — no convite e nos seletores da Equipe.
 *
 * `papelAtual` cobre quem já está na equipe com um papel que hoje está oculto: sem ele na lista,
 * o `<select>` teria um `value` fora das opções e renderizaria em branco pra essa pessoa.
 */
export function papeisAtribuiveis(
  mode: DashboardMode,
  papelAtual?: string | null,
  /** Só o proprietário dá o papel de Sócio. */
  incluirSocio = false,
): InviteRole[] {
  const semSocio = mode === "office" ? PAPEIS_DO_BETA_CLINICA : INVITE_ROLES.filter((r) => r !== "PARTNER");
  const base: InviteRole[] = incluirSocio ? ["PARTNER", ...semSocio] : [...semSocio];
  const ehPapelBase = (v: string): v is InviteRole => (INVITE_ROLES as readonly string[]).includes(v);
  if (papelAtual && ehPapelBase(papelAtual) && !base.includes(papelAtual)) return [...base, papelAtual];
  return base;
}

/** `ROLE_LABEL` é neutro de propósito (compartilhado com o backend, texto de notificação) — essa
 *  função só existe pra apresentação em telas de Equipe, onde "Dentista" não faz sentido pra uma
 *  organização só-laboratório. Único papel com leitura diferente por tipo hoje: os outros 5
 *  (Admin/Assistente/Recepção/Visualizador/Owner) já são genéricos o bastante nos dois contextos. */
export function getRoleLabel(role: string, mode: DashboardMode): string {
  if (role === "DENTIST" && mode === "lab") return "Técnico";
  return ROLE_LABEL[role] ?? role;
}
